import React, { useEffect, useState } from 'react';
import { Col, Container, Row, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { toast } from 'react-toastify';
import DataIntegrationForm from './DataIntegrationForm';
import { setLeavePrompt } from '../manage-users/usersSlice';
import { getDataIntegrationById, updateDataIntegrationApi } from './integrationApi';
import PageHeader from '../../components/PageHeader';

const EditDataIntegration = () => {
  const { id } = useParams();
  const intId = parseInt(id, 10);
  const orgId = useSelector((s) => s.users.user.usrOrgId);
  const history = useHistory();
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const [initialValues, setInitialValues] = useState(null);

  useEffect(() => {
    const load = async () => {
      try {
        const integration = await getDataIntegrationById(orgId, intId);
        setInitialValues({
          name: integration.name || '',
          dataType: integration.dataType || 'EMISSION_CUSTOM',
          connectType: integration.connectType || 'FTP',
          hostname: integration.hostname || '',
          port: integration.port || '',
          username: integration.username || '',
          password: '********',
          remoteDir: integration.remoteDir || '',
          activated: !!integration.activated,
          dataExpectedFrequency: integration.dataExpectedFrequency || null,
          dataNotifyEnabled: !!integration.dataNotifyEnabled,
          notificationEmails: integration.notificationEmails || '',
          fieldMap: Array.isArray(integration.fieldMap) ? integration.fieldMap : [],
        });
      } catch {
        toast.error('Failed to load integration');
        history.push('/admin/settings/data-integrations');
      }
    };
    if (orgId && intId) load();
  }, [orgId, intId, history]);

  const handleSubmit = async (formData) => {
    const payload = {
      name: formData.name,
      dataType: formData.dataType,
      connectType: formData.connectType,
      hostname: formData.hostname,
      port: formData.port ? parseInt(formData.port, 10) : null,
      username: formData.username,
      password: formData.password,
      remoteDir: formData.remoteDir || null,
      activated: !!formData.activated,
      fieldMap: formData.fieldMap || [],
      dataExpectedFrequency: formData.dataExpectedFrequency || null,
      dataNotifyEnabled: !!formData.dataNotifyEnabled,
      notificationEmails: formData.notificationEmails || null,
    };

    try {
      await updateDataIntegrationApi(orgId, intId, payload);
      toast.success('Data integration is updated');
      history.push('/admin/settings/data-integrations');
    } catch (err) {
      toast.error(err.message || 'Update failed');
      dispatch(setLeavePrompt(true));
    }
  };

  const handleCancel = () => history.push('/admin/settings/data-integrations');

  return (
    <Container fluid>
      <Row>
        <Col>
          <PageHeader title={t('Edit Data Integration')} enableBackButton />
        </Col>
      </Row>
      {
        initialValues ? (
          <DataIntegrationForm
            isEditing
            submitText={t('Update')}
            initialValues={initialValues}
            onSubmit={handleSubmit}
            onCancel={handleCancel}
          />
        ) : (<Row> <Col><Spinner animation="grow" /></Col></Row>)
      }
    </Container>
  );
};

export default EditDataIntegration;
